export const textOrDash = (text?: string) => {
  return text ? text : '-';
};
